import React from "react";
import star from "../../assets/images/devdetail/starbt.png";
import location from "../../assets/images/devreview/locationdev.svg";
import phone from "../../assets/images/devreview/phonedev.svg";
import verified from "../../assets/images/devreview/verifieddev.svg";
import { useState } from "react";

const itemdata = [
  {
    id: "item1",
    title: "Project summary",
  },
  {
    id: "item2",
    title: "Feedback summary",
  },
  {
    id: "item3",
    title: "Opportunity / Challenge",
  },
  {
    id: "item4",
    title: "Solution",
  },
];

const ReviewDetailSidebar = ({ onIdSelect }) => {
  const [activeId, setActiveId] = useState("item1");

  const handleItemClick = (itemId) => {
    const itemElement = document.getElementById(itemId);
    itemElement.scrollIntoView();
    setActiveId(itemId);
    onIdSelect(itemId);
  };

  return (
    <div className='review-sidebar-content'>
      <div className='review-sidebar'>
        <div className=' dev-detail-reviews'>
          <ul>
            <li>
              <img src={star} alt='' className='dev-detail-content-top-img' />
              5.0
            </li>
            <li>7 reviews</li>
          </ul>
        </div>
        <div className='review-sidebar-item'>
          <ul>
            {itemdata.map((itemdata) => (
              <li
                key={itemdata.id}
                onClick={() => handleItemClick(itemdata.id)}
                className={activeId === itemdata.id ? "active" : ""}
              >
                {itemdata.title}
              </li>
            ))}
          </ul>
        </div>
        <div className='review-sidebar-detail'>
          <div className='review-detail'>
            <img src={location} alt='location' />
            <p>Denmark</p>
          </div>
          <div className='review-detail'>
            <img src={phone} alt='location' />
            <p>Phone Interview</p>
          </div>
          <div className='review-detail'>
            <img src={verified} alt='location' />
            <p>Verified</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewDetailSidebar;
